export interface HighlightedText {
    before: string;
    match: string;
    after: string;
}

/**
 * Divide `text` en 3 fragmentos alrededor de la primera coincidencia
 * (case-insensitive) de `query`, para resaltarla en la plantilla con 3
 * `<span>` en vez de `[innerHTML]` — `text` viene de resultados de
 * búsqueda del backend y `query` de lo que escribe el usuario, así que se
 * evita cualquier riesgo de inyección. `text` puede llegar null/undefined:
 * /api/search devuelve `dynamic` y `display`/`term` no siempre vienen
 * informados en los datos reales, aunque el tipo SearchResult diga string.
 */
export function highlightMatch(text: string | null | undefined, query: string): HighlightedText {
    const safeText = text ?? '';

    if (!query) {
        return { before: safeText, match: '', after: '' };
    }

    const index = safeText.toLocaleLowerCase().indexOf(query.toLocaleLowerCase());
    if (index === -1) {
        return { before: safeText, match: '', after: '' };
    }

    return {
        before: safeText.slice(0, index),
        match: safeText.slice(index, index + query.length),
        after: safeText.slice(index + query.length)
    };
}
